import type { FC } from 'react';

import type { FragmentType } from '@packages/gql/generated/shopping';
import { getFragmentData, makeFragmentData } from '@packages/gql/generated/shopping';
import { InspiringSearchSuggestionFragmentFragmentDoc } from '@packages/gql/generated/shopping/InspiringSearchSuggestionFragmentFragmentDoc';
import { SearchProductCardResultFragmentFragmentDoc } from '@packages/gql/generated/shopping/SearchProductCardResultFragmentFragmentDoc';

import { SearchProductCard } from '../SearchProductCard';
import { InspiringSearchSuggestionLayout } from './InspiringSearchSuggestion.Layout';

/* GraphQL */ `
  fragment InspiringSearchSuggestionFragment on SuggestionPreview {
    id
    items {
      styleId
      ...SearchProductCardFragment
    }
    query
    activeFilters {
      filterId
      activeValues {
        id
      }
    }
  }
`;

export type InspiringSearchSuggestionProps = {
  maskedSuggestion: FragmentType<typeof InspiringSearchSuggestionFragmentFragmentDoc>;
};

export const InspiringSearchSuggestion: FC<InspiringSearchSuggestionProps> = ({
  maskedSuggestion,
}) => {
  const { id, query, items, activeFilters } = getFragmentData(
    InspiringSearchSuggestionFragmentFragmentDoc,
    maskedSuggestion,
  );

  return (
    <InspiringSearchSuggestionLayout query={query} activeFilters={activeFilters}>
      {items.map((item) => ({
        id: item.styleId,
        node: (
          <SearchProductCard
            maskedItem={item}
            maskedResult={makeFragmentData(
              {
                id: id || '',
                categories: [],
                defaultDisplayMode: 'CARDS',
                abTesting: null,
              },
              SearchProductCardResultFragmentFragmentDoc,
            )}
          />
        ),
      }))}
    </InspiringSearchSuggestionLayout>
  );
};
